import React, { useEffect } from "react";
import ResourcesTab from "./ResourcesTab";
import { Link } from "react-router-dom";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
const Calculators = () => {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const { t: tLang, i18n: i18nLang } = useTranslation();
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="resources-calculators-page" tabIndex={-1}>
                        Resources
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="6" />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <em className="las la-calculator"></em>
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("resourcesSection.calculator.title")}</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>{tLang("resourcesSection.calculator.description.boxDescription")}</p>
                            </div>
                            <div className="box-actions"></div>
                        </div>
                        <div className="box-content">
                            <div className="resource-container">
                                <Link to="/resources/loan-calculator" onClick={() => window.addToDataLayer({ event: "Loan Comparison" })} className="resource-link">
                                    <span className="resource-icon">
                                        <RenderIcons iconName="comments" color="#00313C " width="28" />
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.calculator.label.loanComparison")}</span>
                                        <span className="resource-description">
                                            {tLang("resourcesSection.calculator.description.loanComparison")}
                                        </span>
                                    </span>
                                </Link>
                            </div>

                            <div className="resource-container">
                                <Link
                                    to="/resources/ccc-calculator"
                                    onClick={() => window.addToDataLayer({ event: "Credit Card Comparison" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <RenderIcons iconName="credit-card" color="#00313C " width="28" />
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.calculator.label.creditCardComparison")}</span>
                                        <span className="resource-description">
                                            {tLang("resourcesSection.calculator.description.creditCardComparison")}
                                        </span>
                                    </span>
                                </Link>
                            </div>

                            <div className="resource-container">
                                <Link
                                    to="/resources/auto-lease-buy-calculator"
                                    onClick={() => window.addToDataLayer({ event: "Auto Lease vs Buy" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-car"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.calculator.label.autoLeasevsBuy")}</span>
                                        <span className="resource-description">
                                            {tLang("resourcesSection.calculator.description.autoLeasevsBuy")}
                                        </span>
                                    </span>
                                </Link>
                            </div>

                            <div className="resource-container">
                                <Link
                                    to="/resources/mortgage-qualification-calculator"
                                    onClick={() => window.addToDataLayer({ event: "Mortgage Qualification" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <RenderIcons color="#00313C " width="28" iconName="home" />
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.calculator.label.mortgageQualification")}</span>
                                        <span className="resource-description">
                                            {tLang("resourcesSection.calculator.description.mortgageQualification")}
                                        </span>
                                    </span>
                                </Link>
                            </div>

                            <div className="resource-container">
                                <Link
                                    to="/resources/debt-consolidation-calculator"
                                    onClick={() => window.addToDataLayer({ event: "Debt Consolidation" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <RenderIcons iconName="coins" color="#00313C " width="28" />
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.calculator.label.debtConsolidation")}</span>
                                        <span className="resource-description">
                                            {tLang("resourcesSection.calculator.description.debtConsolidation")}
                                        </span>
                                    </span>
                                </Link>
                            </div>

                            <div className="resource-container">
                                <Link
                                    to="/resources/mortage-refinancing-calculator"
                                    onClick={() => window.addToDataLayer({ event: "Mortgage Refinancing" })}
                                    className="resource-link"
                                >
                                    <span className="resource-icon">
                                        <em className="las la-percentage"></em>
                                    </span>
                                    <span className="resource-text">
                                        <span className="resource-title">{tLang("resourcesSection.calculator.label.mortageRefinancing")}</span>
                                        <span className="resource-description">
                                            {tLang("resourcesSection.calculator.description.mortageRefinancing")}
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Calculators;
